import {IDirectiveLinkFn} from "angular";

import {MomentInput, Moment} from "moment";

export const TimeAgo = "tfTimeAgo";

let functions: Array<() => void> = [];

/* Once per minute try and update everything */
setInterval(() => {
    functions.forEach((i) => i());
}, 60000);

/** This is a butchering of the Angular Moment library to try and make it not spam the digest quite so much */
/** @ngInject */
export function timeAgo(moment: any, amMoment: any, amTimeAgoConfig: any): IDirectiveLinkFn {
    return ($scope, $element, $attr) => {
        let currentValue: MomentInput | null = null;

        const withoutSuffix = amTimeAgoConfig.withoutSuffix;
        const fullDateThreshold = amTimeAgoConfig.fullDateThreshold;
        const fullDateFormat = amTimeAgoConfig.fullDateFormat;
        const fullDateThresholdUnit = amTimeAgoConfig.fullDateThresholdUnit;

        const localDate = new Date().getTime();
        const modelName = $attr.tfTimeAgo;
        const currentFrom: Moment | null = null;

        function getNow() {
            let now;
            if (currentFrom != null) {
                now = currentFrom;
            } else if (amTimeAgoConfig.serverTime) {
                const localNow = new Date().getTime();
                const nowMillis = localNow - localDate + amTimeAgoConfig.serverTime;
                now = moment(nowMillis);
            } else {
                now = moment();
            }
            return now;
        }

        function updateTime(momentInstance: Moment) {
            const diff = getNow().diff(momentInstance, fullDateThresholdUnit);
            const showFullDate = fullDateThreshold && diff >= fullDateThreshold;

            if (showFullDate) {
                $element[0].innerHTML = momentInstance.format(fullDateFormat);
            } else {
                $element[0].innerHTML = momentInstance.from(getNow(), withoutSuffix);
            }
        }

        function updateMoment() {
            if (currentValue != null) {
                const momentValue = amMoment.preprocessDate(currentValue);
                updateTime(momentValue);
            }
        }

        $scope.$watch(modelName, (value: MomentInput) => {
            if ((value == null) || (value === "")) {
                if (currentValue != null) {
                    $element[0].innerHTML = "";
                    currentValue = null;
                }
                return;
            }

            currentValue = value;
            updateMoment();
        });

        functions = [updateMoment].concat(functions);

        $scope.$on("$destroy", () => {
            functions = functions.filter((f) => f !== updateMoment);
        });
    };
}
